import { useEditorContext } from '@bay-email/editor';
import { useMemo } from 'react';

/**
 * Hook to get page theme defaults
 * Returns default values from page.data.value for use as placeholders
 */
export function usePageDefaults() {
  const { pageData } = useEditorContext();

  return useMemo(() => {
    const defaults = pageData?.data?.value || {};

    return {
      fontFamily: defaults['font-family'] || 'Arial, sans-serif',
      fontSize: defaults['font-size'] || '14px',
      lineHeight: defaults['line-height'] || '1.7',
      fontWeight: defaults['font-weight'] || '400',
      letterSpacing: defaults['letter-spacing'] || '0px',
    };
  }, [pageData]);
}

